import React from "react";
import { Link } from "react-router-dom";

// A link to one of the installation's legal documents (URLs from useInstanceInfo).
// A URL starting with "/" is an in-app route (the built-in /legal/* pages) and uses the router,
// unless newTab is set; anything else (including a protocol-relative "//host" URL) opens
// externally in a new tab. No URL renders nothing: an unset document is not linked.
const LegalLink = ({ url, children, className, newTab }) => {
    if (!url) return null;

    if (url.startsWith("/") && !url.startsWith("//") && !newTab) {
        return <Link to={url} className={className}>{children}</Link>;
    }

    return (
        <a href={url} target="_blank" rel="noopener noreferrer" className={className}>
            {children}
        </a>
    );
};

export default LegalLink;
